import {
  selectDiscoveryCurrency,
  selectDiscoveryId,
  selectDiscoveryMetric
} from "../../../../store/reducers";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import * as PropTypes from "prop-types";
import { SettingsContext } from "../../../../components/SettingsProvider";
import TooltipIcon from "../../../../components/TooltipIcon";
import { Text } from "../../../../components";
import { useContext } from "react";
import styled from "styled-components";
import { formatMetric } from "../../../../utils/formatting";
import { useMobileMediaQuery } from "../../../../components/Responsive";
import { CommentsButton } from "../../../../components/Discovery/Comments";

const ReportMetric = ({ currency, metric, discoveryId, reportId }) => {
  const isMobile = useMobileMediaQuery();
  const { settings } = useContext(SettingsContext);
  const localSettings = { ...settings, currency };

  return (
    <ReportMetricContainer className={isMobile ? "mobile" : undefined}>
      <Text variant={isMobile ? "bMediumMobile" : "bMedium"}>
        {formatMetric({
          type: metric.type,
          value: metric.value,
          options: localSettings
        })}
      </Text>
      <MetricNameRow>
        <TextNoBreak variant={isMobile ? "bodyMobile" : "body"}>
          {metric.name}&nbsp;
          <TooltipIcon title={metric.description} />
        </TextNoBreak>
        <div className="visible-on-hover">
          <CommentsButton
            topic={`/discoveries/${discoveryId}/metrics/${metric.metricCode}`}
            reportId={reportId}
          />
        </div>
      </MetricNameRow>
    </ReportMetricContainer>
  );
};

const MetricNameRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
`;

const TextNoBreak = styled(Text)`
  page-break-inside: avoid;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
`;

const ReportMetricContainer = styled.div`
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  page-break-inside: avoid;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;

  &.mobile {
    padding-bottom: 16px;
  }

  &:hover .question-icon-bar {
    visibility: visible;
  }

  & .visible-on-hover {
    display: inline-block;
    visibility: hidden;

    & .open-comments-button-open,
    & .open-comments-button-has-comments {
      visibility: visible;
    }
  }

  &:hover .visible-on-hover,
  &:focus-within .visible-on-hover {
    visibility: visible;
  }

  &.mobile .visible-on-hover {
    visibility: visible;
  }
`;

ReportMetric.propTypes = {
  metricCode: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => ({
  discoveryId: selectDiscoveryId(state),
  currency: selectDiscoveryCurrency(state),
  metric: selectDiscoveryMetric(state, props.metricCode)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ReportMetric
);
